import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './IdentityInfo.module.css'
import { Col, Flex, Row, Select, Space } from 'antd'
import classNames from 'classnames'
import { ReactComponent as DeleteIcon } from './delete.svg'
// import deleteIcon1 from './delete1.svg'
export default function IdentityInfo(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [identityTypeList, setIdentityTypeList] = useState([
    {
      label: '学科老师',
      value: '1',
    },
    {
      label: '班主任',
      value: '2',
    },
    {
      label: '其他',
      value: '3',
    },
  ])

  // const incrementValue = Number(incrementAmount) || 0;
  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    console.log('---------->>aslkdfj')
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  return (
    <Flex vertical={false} gap={16} style={{ marginTop: 16 }}>
      <Select
        placeholder="请选择身份类型"
        size="large"
        style={{ backgroundColor: 'white', minWidth: 120, width: 120 }}
        options={identityTypeList}
        value={props.info.type}
        onChange={(index, typeInfo) => {
          props.handleIdentityTypeChange(props.index, typeInfo)
        }}
      />
      <Flex vertical={false} gap={16} style={{ minWidth: 510, width: 510 }}>
        <Select
          placeholder="请选择学科"
          size="large"
          style={{ backgroundColor: 'white' }}
          options={props.xuekeList.map((item) => ({
            label: item.name,
            value: item.code,
          }))}
          value={props.info.xueke_code}
          onChange={(index, typeInfo) => {
            props.handleXuekeChange(props.index, typeInfo)
          }}
        />
        <Select
          placeholder="请选择年级"
          size="large"
          style={{ backgroundColor: 'white' }}
          options={props.gradeList.map((item) => ({
            label: item.name,
            value: item.code,
          }))}
          value={props.info.nianji_code}
          onChange={(index, typeInfo) => {
            props.handleGradeChange(props.index, typeInfo)
          }}
        />
      </Flex>
      {/* <img className={styles.deleteIcon} src={deleteIcon} alt="" /> */}
      <DeleteIcon
        className={styles.deleteIcon}
        onClick={() => {
          props.handleDelete(props.index)
        }}
      />
    </Flex>
  )
}
